import { termsMap } from '@elem/compPage/next-level-power/config/terms';
import EfFooterTc from '@elem/ui/ef-footer-tc';
import { useRouter } from 'next/router';
import styles from './index.module.scss';

export default function TheComp() {
    const { locale } = useRouter();
    const termsData = termsMap[locale as keyof typeof termsMap] || termsMap.eu;

    return (
        <div className={styles.TheComp}>
            <EfFooterTc list={termsData} />
        </div>
    );
}
